var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectMultielementCross = function SvgSelectMultielementCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.616,
    height: 9.697,
    x: 6.856,
    fill: "currentColor",
    rx: 0.808,
    transform: "rotate(45 6.856 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.616,
    height: 9.697,
    x: 0.001,
    y: 1.143,
    fill: "currentColor",
    rx: 0.808,
    transform: "rotate(-45 .001 1.143)"
  })));
};
export { SvgSelectMultielementCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9Im5vbmUiPjxyZWN0IHdpZHRoPSIxLjYxNiIgaGVpZ2h0PSI5LjY5NyIgeD0iNi44NTYiIGZpbGw9ImN1cnJlbnRDb2xvciIgcng9Ii44MDgiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDYuODU2IDApIi8+PHJlY3Qgd2lkdGg9IjEuNjE2IiBoZWlnaHQ9IjkuNjk3IiB4PSIuMDAxIiB5PSIxLjE0MyIgZmlsbD0iY3VycmVudENvbG9yIiByeD0iLjgwOCIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IC4wMDEgMS4xNDMpIi8+PC9zdmc+";